import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  outlineBtn: {
    padding: theme.spacing(2),
    color: "#2B59C3",
    fontSize: "14px !important",
  },
}));
